export const CLEAR_ERROR_BY_IDENTIFIER = 'CLEAR_ERROR_BY_IDENTIFIER';

export const clearErrorByCode = (identifier: string) => ({
    type: CLEAR_ERROR_BY_IDENTIFIER,
    payload: { identifier },
});
